// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b0761545","952":"85f35471"}[chunkId] + ".chunk.js";
};